// src/services/purchases.js — Admin → Purchases data (admin-only reads; every
// change goes through /api/link-purchase or /api/purchase-sweep). See
// api/_purchases.js for the model and why it exists.

import { db, firebaseEnabled } from './firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

// Matches api/_purchases.js ATTENTION_GRACE_MS: a guest normally links within
// minutes on /welcome, so nothing is flagged until an hour has passed.
export const ATTENTION_GRACE_MS = 60 * 60 * 1000;

export function subscribeAttentionPurchases(onUpdate) {
    if (!firebaseEnabled || !db) { onUpdate([]); return () => {}; }
    const q = query(collection(db, 'programPurchases'), where('attention', '==', true));
    return onSnapshot(q, (snap) => {
        const cutoff = Date.now() - ATTENTION_GRACE_MS;
        onUpdate(snap.docs.map((d) => d.data())
            .filter((p) => Date.parse(p.purchasedAt || p.createdAt || 0) <= cutoff)
            .sort((a, b) => String(a.purchasedAt).localeCompare(String(b.purchasedAt))));
    }, (err) => { console.error('subscribeAttentionPurchases:', err); onUpdate([]); });
}

async function post(path, body, getToken) {
    try {
        const token = await getToken();
        const r = await fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify(body) });
        const data = await r.json().catch(() => ({}));
        return { ok: r.ok, data };
    } catch (e) { return { ok: false, data: {} }; }
}

export const linkPurchaseToMember = (sessionId, userId, podId, getToken) => post('/api/link-purchase', { sessionId, action: 'link', userId, podId: podId || null }, getToken);
export const dismissPurchase = (sessionId, reason, getToken) => post('/api/link-purchase', { sessionId, action: 'dismiss', reason }, getToken);
export const runPurchaseCheckNow = (getToken) => post('/api/purchase-sweep', {}, getToken);
